export track = (event, properties) ->
  analytics?.track(event, properties)

export identify = (traits = {}) ->
  analytics?.identify(
    Weaver.getInstance().currentUser().userId,
    traits
  )